import {Discount} from './discount';

export class BankBilletData {
  barcode: string;
  bankBilletURL: string;
  invoiceDate: string;
  totalValue: number;
  expirationDate: string;
  appliedCoupons: Array<Discount>;
  errorMsg: string;
  chargedUser: boolean;
  status: string;
  discountedValue: number;
  invoiceId: string;
  hideExpirationDate: boolean;
  planName: string;
  remember: string

  constructor(bankBilletData?: any) {
    if(bankBilletData){
      this.barcode = bankBilletData.barcode;
      this.bankBilletURL = bankBilletData.bankBilletURL;
      this.invoiceDate = bankBilletData.invoiceDate;
      this.totalValue = bankBilletData.totalValue;
      this.expirationDate = bankBilletData.expirationDate;
      this.discountedValue = bankBilletData.discountedValue;
      this.status = bankBilletData.status;
      this.errorMsg = bankBilletData.errorMsg;
      this.chargedUser = bankBilletData.chargedUser;
      this.invoiceId = bankBilletData.invoiceId;
      this.hideExpirationDate = bankBilletData.hideExpirationDate;
      this.planName = bankBilletData.planName;
      this.remember = bankBilletData.remember;

      if(bankBilletData.appliedCoupons && bankBilletData.appliedCoupons.length){
        this.appliedCoupons = bankBilletData.appliedCoupons.map(coupon => new Discount(coupon));
      }
    }
  }
}
